import { endpoints } from "@cayo/shared/services/endpoints.service";
import { ConfigEXO, ConfigTeams, SmtpChannelConfig } from "./types";

export function getConsentUrl(data: {
  credentialType?: string;
  appUrl: string;
  accountName: string;
}) {
  return fetch(`${endpoints.publicUrl}/v0/configuration/connectionCredentials/getConsentUrl`, {
    method: "POST",
    body: JSON.stringify(data),
  }).then((res) => res.json());
}

export function getConnectors() {
  return fetch(
    `${
      endpoints.publicUrl
    }/v0/alerting/connectors?$top=300&$orderby=createdDateTime+desc&$select=id,objectPath,objectType,builtIn,snapshotDateTime,categories,disabled,errors,name,description,senderDetails,recipientDetails&time=${Date.now()}`
  );
}

export function getSigninConsentUrl(data: { appUrl: string; accountName: string }) {
  return fetch(
    `${endpoints.publicUrl}/v0/configuration/connectionCredentials/getSigninConsentUrl`,
    {
      method: "POST",
      body: JSON.stringify({
        appUrl: data.appUrl,
        accountName: data.accountName,
      }),
    }
  ).then((res) => res.json());
}

export function exchangeAuthCode(data: {
  serviceType: string;
  authorizationCode: string;
  accountName: string;
}) {
  return fetch(`${endpoints.publicUrl}/v0/configuration/managedTenants/exchangeAuthCode`, {
    method: "POST",
    body: JSON.stringify(data),
  }).then((res) => res.json());
}

export function promotePermissions(data: {
  credentialType: string;
  accountName: string;
  refreshToken: string;
}) {
  return fetch(`${endpoints.publicUrl}/v0/configuration/connectionCredentials/promotePermissions`, {
    method: "POST",
    body: JSON.stringify(data),
  }).then((res) => res.json());
}

// ADD EXO
export function addExchangeOnlineConnector(data: ConfigEXO, finished: () => void) {
  return new Promise((resolve, reject) => {
    fetch(`${endpoints.publicUrl}/v0/alerting/connectors/addExchangeOnlineConnector`, {
      method: "POST",
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const ok = response.ok;

        return await Promise.resolve({ ok, response });
      })
      .then(({ ok, response }) => {
        if (ok) {
          finished();
          return resolve(ok);
        }

        reject(response);
      })
      .catch((e) => reject(e));
  });
}

// configure EXO
export function configureExchangeOnlineConnector(
  id: string,
  data: ConfigEXO,
  finished: () => void
) {
  return new Promise((resolve, reject) => {
    fetch(
      `${endpoints.publicUrl}/v0/alerting/connectors/${id}/cayo.graph.mailConnector/configureCredential`,
      {
        method: "POST",
        body: JSON.stringify(data),
      }
    )
      .then(async (response) => {
        const ok = response.ok;

        return await Promise.resolve({ ok, response });
      })
      .then(({ ok, response }) => {
        if (ok) {
          finished();
          return resolve(ok);
        }

        reject(response);
      })
      .catch((e) => reject(e));
  });
}

// ADD Teams
export function addTeamsConnector(data: ConfigTeams, finished: () => void) {
  return new Promise((resolve, reject) => {
    fetch(`${endpoints.publicUrl}/v0/alerting/connectors/addTeamsConnector`, {
      method: "POST",
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const ok = response.ok;

        return await Promise.resolve({ ok, response });
      })
      .then(({ ok, response }) => {
        if (ok) {
          finished();
          return resolve(ok);
        }

        reject(response);
      })
      .catch((e) => reject(e));
  });
}

//configure Teams
export function configureTeamsConnector(id: string, data: ConfigEXO, finished: () => void) {
  return new Promise((resolve, reject) => {
    fetch(
      `${endpoints.publicUrl}/v0/alerting/connectors/${id}/cayo.graph.teamsConnector/configureCredential`,
      {
        method: "POST",
        body: JSON.stringify(data),
      }
    )
      .then(async (response) => {
        const ok = response.ok;

        return await Promise.resolve({ ok, response });
      })
      .then(({ ok, response }) => {
        if (ok) {
          finished();
          return resolve(ok);
        }

        reject(response);
      })
      .catch((e) => reject(e));
  });
}

// ADD SMTP
export function addSmtpConnector(data: SmtpChannelConfig, finished: () => void) {
  return new Promise((resolve, reject) => {
    fetch(`${endpoints.publicUrl}/v0/alerting/connectors/addSmtpConnector`, {
      method: "POST",
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const ok = response.ok;

        return await Promise.resolve({ ok, response });
      })
      .then(({ ok, response }) => {
        if (ok) {
          finished();
          return resolve(ok);
        }

        reject(response);
      })
      .catch((e) => reject(e));
  });
}

//configure SMTP
export function configureSmtpConnector(
  id: string,
  data: {
    accountName: string;
    accountPassword: string;
  },
  finished: () => void
) {
  return new Promise((resolve, reject) => {
    fetch(
      `${endpoints.publicUrl}/v0/alerting/connectors/${id}/cayo.graph.smtpConnector/configureCredential`,
      {
        method: "POST",
        body: JSON.stringify(data),
      }
    )
      .then(async (response) => {
        const ok = response.ok;

        return await Promise.resolve({ ok, response });
      })
      .then(({ ok, response }) => {
        if (ok) {
          finished();
          return resolve(ok);
        }

        reject(response);
      })
      .catch((e) => reject(e));
  });
}
